import { DeliveryPoint } from "services/interface";
import styled from "@emotion/styled";
import { Col, Row, message } from "antd";
import { Dispatch, FC, SetStateAction } from "react";
import TableDeliveryPoint from "./TableDelivery";
import { useDeleteDeliveryPoint } from "hooks/useShipping";

interface DeliveryListProps {
  data: DeliveryPoint | undefined;
  refetch: () => void;
  limit: number;
  offset: number;
  setLimit: Dispatch<SetStateAction<number>>;
  setOffset: Dispatch<SetStateAction<number>>;
}

const DeliveryList: FC<DeliveryListProps> = ({
  data,
  refetch,
  limit,
  offset,
  setLimit,
  setOffset,
}) => {
  const { mutate: DeleteDelivery, isPending: deleteLoading } =
    useDeleteDeliveryPoint();

  const onDeleteConfigs = (id: string) => {
    DeleteDelivery(
      {
        id: id,
      },
      {
        onSuccess: (res) => {
          if (res.status === "success") {
            message.success("ลบสำเร็จ");
            refetch();
          } else {
            message.error(`ลบไม่สำเร็จ: ${res.error_message}`);
          }
        },
        onError: (error) => {
          message.error(`ลบไม่สำเร็จ: ${error.message}`);
        },
      }
    );
  };

  return (
    <WrapperAll>
      <Row
        gutter={[16, 16]}
        style={{ overflow: "auto" }}
      >
        <Col span={24}>
          <CardWrapperTable>
            <TableDeliveryPoint
              data={data?.data}
              onDeleteConfigs={onDeleteConfigs}
              limit={limit}
              offset={offset}
              setLimit={setLimit}
              setOffset={setOffset}
              total={data?.total_record}
            />
          </CardWrapperTable>
        </Col>
      </Row>
    </WrapperAll>
  );
};

export default DeliveryList;
const WrapperAll = styled.div`
  padding: 16px 0px 10px 0px;
`;

const CardWrapperTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  background-color: #ffffff;
  padding: 5px;
`;
